export default __webpack_public_path__ + "static/media/icon_1.c7570f26.png";